export const SocialData=[
    {
        platform:"Github",
        icon: require("../../assets/icons/github.png"),
        link:"https://github.com/Keshab66",
    },
    {
        platform:"Linkedin",
        icon: require("../../assets/icons/linkedin.png"),
        link:"https://www.linkedin.com/in/keshaba-pradhan-257919201/",
    },
    {
        platform:"Youtube",
        icon: require("../../assets/icons/youtube.png"),
        link:"",
    },
    {
        platform:"Twitter",
        icon: require("../../assets/icons/twitter.png"),
        link: "",
    },
    {
        platform:"Facebook",
        icon: require("../../assets/icons/facebook.png"),
        link:"",
    },
];